var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4205 8.42674L8.8125 20.3447L21.4568 32.2971L34.0648 20.3791L21.4205 8.42674Z",
    fill: "#367EB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0616 20.3792L21.4536 32.2973L8.80697 20.3428L3.42188 25.4332L17.6964 38.9387C19.7785 40.9109 23.1501 40.9149 25.2407 38.9508L26.0118 38.2219L39.4682 25.4899L34.0616 20.3792Z",
    fill: "#00AD71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80571 20.3423L21.4138 8.42425L34.0604 20.3788L39.4926 15.2438L24.6611 1.22805C22.5705 -0.246013 19.6016 -0.0880775 17.6995 1.70186L3.39062 15.2276L8.80571 20.3464V20.3423Z",
    fill: "#11C5BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0703 20.3781L39.4768 25.4887L41.169 23.8891C43.0712 22.0911 43.2383 19.2806 41.6788 17.3004L39.5025 15.2432L34.0703 20.3781Z",
    fill: "#11C5BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78887 23.8898L3.4211 25.4368L8.8062 20.3464L3.39112 15.2276L1.77602 16.7543C-0.301765 18.7265 -0.301765 21.9217 1.78458 23.8938L1.78887 23.8898Z",
    fill: "#00AD71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d79f948c7aff16f6c55b3d86cc10f3db.svg";
export { ForwardRef as ReactComponent };